
import  React, {use, useEffect, useRef, useState, useTransition} from 'react';


import '../pages/styles/estandar/FormStyle.css';
import '../pages/styles/estandar/ButtonStyles.css';

import './styles/CreateUserForm.css';
import { CgWebcam } from 'react-icons/cg';
import MensajeError from './MensajeError';
import MensajeAlerta from './MensajeAlerta';
import axios from 'axios';
import { useNavigate, useParams } from "react-router-dom";
import Cookies from 'js-cookie';
import { useConfig } from '../contexts/ConfigContext';


//PePPrA
const EditUserForm = () =>{
    const [idUsuario, setIdUsuario] = useState("");
    const [nombre, setNombre] = useState("");
    const [correo, setCorreo] = useState("");
    const [contraseña, setContraseña] = useState("");
    const [confirmarContraseña, setConfirmarContraseña] = useState("");
    const [ROL, setROL] = useState(0);

    const config = useConfig();
    const API_URL = `${config.API_URL}/api/usuario/`;

    //ERRORES
    const [nombreError, setNombreError] = useState("");
    const [correoError, setCorreoError] = useState("");
    const [contrasenaError, setContrasenaError] = useState("");
    const [confContrasenaErro, setConfContrasenaErro] = useState("");
    const[rolError, setRolError] = useState("");

    //Error generico
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    //Alerta generica
    const [showAlerta, setShowAlerta] = useState(false);
    const [alertaMensaje, setAlertaMensaje] = useState('');

    //Parametro id
    const navigate = useNavigate();
    const { id_usuario } = useParams();

    const [admin, setAdmin] = useState(false);
        const validarSesion = () =>{
                if(Cookies.get("turid")){
                    const turid = Cookies.get("turid");
                    if(turid === "rid1"){
                        setAdmin(true);
                    }else{
                        navigate("/");
                        Cookies.remove("usr");
                        Cookies.remove("turid");
                    }
                }else{
                    navigate("/");
                    Cookies.remove("usr");
                }
    
        }

    useEffect(() =>{

        //Configuramos axios para que añada al header el respectivo token
        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        }
        );


        const cargarDatosUsuario = async() =>{

            //const URL_API = 'http://localhost:5054';


            const JSONRequest = {
                id_usuario : id_usuario
            }
            
            try{
                const absolutePath = API_URL + 'obtener_info';
                const response = await axios.post(absolutePath, JSONRequest, {Authorization: true})

                if(response.status === 200){
                   const data = response.data;
                   setIdUsuario(data["id_usuario"]);
                   setNombre(data["nombre"]);
                   setCorreo(data["correo"]);
                   setROL(data["rol"])
                        
                }else{
                    alert("No se encontro el usuario");
                }
            }catch(error){
                alert(error.status);
            }
        }

        cargarDatosUsuario();
    },[]);

    const limpiarErrores = () =>{
        setNombreError('');
        setCorreoError('');
        setContrasenaError('');
        setConfContrasenaErro('');
        setRolError('');
    }

    const editarUsuario = async(e) => {
        e.preventDefault();

        //Configuramos axios para que añada al header el respectivo token
        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        }
        );

        var cambiar_contrasena = false;
        if(contraseña !== ''){
            cambiar_contrasena = true;
        }

        const JSONreq = {
                id_usuario: idUsuario.toString(),
                nombre: nombre,
                correo: correo,
                contrasena: contraseña,
                confirmarContrasena: confirmarContraseña,
                rol: ROL,
                cambio_pass: cambiar_contrasena
        }

        console.log(JSONreq)

        //const URL_API = 'http://localhost:5054';

        try{
            const absolutePath = API_URL + 'modificar_usuario';
            const response = await axios.post(absolutePath, JSONreq, {Authorization: true})

            if(response.status === 200){
                setShowAlerta(true)
                setAlertaMensaje(response.data.mensaje)
            }else{
                setShowError(true)
                setErrorMessage(response.data.mensaje)
            }
        }catch(error){
            if(error.status === 400){
                const JSONErrors = error.response.data;
                console.log(JSONErrors);
                setearErrores(JSONErrors["errors"]);
            }else{
                setShowError(true);
                setErrorMessage(error);
            }
        }






    }

    const setearErrores = (jsonErrores) =>{
        for(const field in jsonErrores){
            if(jsonErrores.hasOwnProperty(field)){
                const errorMessage = jsonErrores[field][0];
                switch(field){
                    case 'usuario':
                        setNombreError(errorMessage);
                        break;
                    case 'correo':
                        setCorreoError(errorMessage);
                        break;
                    case 'contrasena':
                        setContrasenaError(errorMessage);
                        break;
                    case 'confirmarContrasena':
                        setConfContrasenaErro(errorMessage);
                        break;
                    case 'ROL':
                        setRolError(errorMessage);
                        break;
                    case 'existente':
                        setErrorMessage(errorMessage);
                        setShowError(true);
                    default:
                        alert(field)
                        console.warn('Error campo desconocido');

                }
            }
        }
    }


    const handleCloseError = () => {
        setShowError(false); // Oculta el mensaje de error cuando el usuario hace clic en "Aceptar"
        setErrorMessage(''); // Opcional: limpia el mensaje de error
    };

    const handelCloseAlerta = () =>{
        navigate('/adminPanel')
    }

    return(
        <div className='CreateUserForm'>
            <MensajeError mensaje={errorMessage} show={showError} onClose={handleCloseError}/>
            <MensajeAlerta mensaje={alertaMensaje} show={showAlerta} onClose={handelCloseAlerta}/>
            <form className='FormContainer' onSubmit={editarUsuario}>
                <label htmlFor='nombre' className='labelF'>Nombre: </label>
                <input type='text' id='nombre' name='nombre'className='inputF' value={nombre} onChange={(e) => setNombre(e.target.value)} maxLength="300"/>
                {nombreError && <p className='errorMsg'>*{nombreError}</p>}

                <label htmlFor='correo' className='labelF'>Correo:</label>
                <input type='text' id='correo' name='correo' className='inputF' value={correo} onChange={(e) => setCorreo(e.target.value)} maxLength="200"/>
                {correoError && <p className='errorMsg'>*{correoError}</p>}

                <label htmlFor='contrasena' className='labelF'>Nueva contraseña:</label>
                <input type='password' id='contrasena' name='contrasena' className='inputF' value={contraseña} onChange={(e) => setContraseña(e.target.value)} maxLength="50"/>
                {contrasenaError && <p className='errorMsg'>*{contrasenaError}</p>}

                <label htmlFor='confirmarContra' className='labelF'>Confirmar contraseña:</label>
                <input type='password' id='confirmarContra' name='confirmarContra' className='inputF' value={confirmarContraseña} onChange={(e) => setConfirmarContraseña(e.target.value)} maxLength="50"/>
                {confContrasenaErro && <p className='errorMsg'>*{confContrasenaErro}</p>}

                <label htmlFor='rol' className='labelF'>ROL:</label>
                <select value={ROL} className='inputF' onChange={(e) => setROL(e.target.value)}>
                    <option value="100"defaultChecked>Selecciona un rol</option>
                    <option value="1">Administrador</option>
                    <option value="2">Usuario</option>
                </select>
                {rolError && <p className='errorMsg'>*{rolError}</p>}

                <button className='buttonStandartGreen' id='guardarUsuario' type='submit'>Guardar</button>
            </form>
        </div>
    );

}

export default EditUserForm;